module.exports = __webpack_public_path__ + "assets/img/s11.1f43eb13.png";